import { createApp } from 'vue';
import Index from '../components/PropertyPage/Index.vue';

const app = createApp(Index);
app.mount('#propertypagelist');
